module.exports = __webpack_public_path__ + "img/weather65.a9bed5f8.png";